export default __webpack_public_path__ + "static/media/mgDELI-icon.7424806d.png";